import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyCountry = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyCountry);
};
